import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, normalizeStyle as _normalizeStyle, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3bead33c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "MChips p-input-filled",
  "data-testid": "chips"
}
const _hoisted_2 = ["for"]

import Chips from "primevue/chips"
  import { WritableComputedRef, computed } from "vue"

  interface ChipsProps {
    label: string
    modelValue: string[]
    nome: string
    separator: string
    styles?: string
    desativados?: boolean
  }
  
export default /*#__PURE__*/_defineComponent({
  __name: 'MChipsInput',
  props: {
    label: null,
    modelValue: null,
    nome: null,
    separator: null,
    styles: null,
    desativados: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: "update:modelValue", modelValue: string[]): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    label: string
    modelValue: string[]
    nome: string
    separator: string
    styles?: string
    desativados?: boolean
  }

  

  

  const emitirModel: WritableComputedRef<string[]> = computed({
    get(): string[] {
      return props.modelValue
    },
    set(value: string[]) {
      emits("update:modelValue", value)
    },
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createElementVNode("label", { for: __props.nome }, _toDisplayString(__props.label), 9, _hoisted_2),
    _createVNode(_unref(Chips), {
      modelValue: _unref(emitirModel),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(emitirModel) ? (emitirModel).value = $event : null)),
      id: __props.nome,
      disabled: __props.desativados,
      separator: __props.separator,
      style: _normalizeStyle(__props.styles)
    }, null, 8, ["modelValue", "id", "disabled", "separator", "style"])
  ]))
}
}

})